export const getUserProfileImage = (email: string) =>
  `/graph/v1.0/users/${email}/photos/48x48/$value`;
